import type { IProductCard, IVariantCard } from "./product";

export const isFullProductCard = (
  product: IProductCard | IVariantCard
): product is IProductCard =>
  (product as IProductCard)?.variants?.default !== undefined;
